import { Spin } from 'antd'
import Button from 'components/Button'
import Control from 'components/Control/Control'
import AddIcon from 'components/icons/AddIcon'
import ExperienceForm from '../ProjectForm'
import React, { useEffect, useState } from 'react'

import { Form } from 'antd'
import { SpinWrapper } from '../../../../../../OnBoarding/Register/Education/style'
import {
  AdjustIcon,
  FooterFlex,
  StyledDrawer,
} from '../../DrawerStyle'
import {
  ButtonLocal,
  Text,
} from '../style'

import { searchAPI, setResumeData } from '../../../../../../OnBoarding/actions'
import { SubHeading1 } from '../../EducationDetailStyle'
import { useDispatch } from 'react-redux'
import ErrorMessage from 'utils/ErrorMessage'
import SuccessMessage from 'utils/SuccessMessage'
import { searchConfig } from 'utils/config'
import { getStudentDataById } from '../../../../../actions'
import instRequest from '../../../../../../../utils/instRequest'
import instituteRequest from '../../../../../../../utils/instituteRequest'
import UpdatePopup  from '../../../UpdatePopup'
import SuccessPopupModal from '../../../SuccessPopup'
const WorkExperienceDrawer = ({
  drawerStatus,
  setdrawerStatus,
  updateStudentData,
  studentFormData,
  pendingData,
  getPendingData,
  listOfStudentSkills,
  setRoleDrawer,
  itemId,
  setLoading,
  roleDrawer = false,
  getEligibleDetails,
  getRoleFloatDetails,
  setExpDrawer,
  expDrawer,
  getListOfSkills,
  studentId,
}) => {
  const [form] = Form.useForm()
  const [experience, setExperience] = useState([])
  const [isPresent, setIsPresent] = useState(false)
  const [skillLoading, setSkillLoading] = useState(false)
  const [submitLoading, setSubmitLoading] = useState(false)
  const [corporateName, setCorporateName] = useState([])
  const [corporateId, setCorporateId] = useState('')
  const [isUpdateButtonEnabled, setIsUpdateButtonEnabled] = useState(true)
  const [listOfSkills, setListOfSkills] = useState([])
  const [shown, setShown] = useState([])
  const [isExpUpdated, setIsExpUpdated] = useState(false)
  const [updated, setUpdated] = useState(false)
  const [listOfAddedSkills, setListOfAddedSkills] = useState([])
  const [tpoConfig, setTpoConfig] = useState(null)
  const [frozenFieldsMap, setFrozenFieldsMap] = useState({})
  const [isAddNewFrozen, setIsAddNewFrozen] = useState(false)
  const [showUpdatePopup, setShowUpdatePopup] = useState(false)
  const [succesPopup, setSuccessPopup] = useState(false)
  const SkillsAPI = async (page, search) => {
    try {
      const results = await dispatch(
        searchAPI(searchConfig?.skills?.name, search, searchConfig?.skills)
      )

      let updatedSkills = results || []
      let v = {
        name: search,
        id: Math.random().toString(36).substr(2, 8),
      }
      if (updatedSkills?.length === 0 && search) {
        setListOfAddedSkills([...listOfAddedSkills, v])
        setListOfSkills([...updatedSkills, v])
      }
      const isExactMatch = updatedSkills?.some(
        skill => skill?.name.toLowerCase() === search?.toLowerCase()
      )
      if (updatedSkills?.length > 0) {
        if (!isExactMatch && search?.length > 3) {
          setListOfAddedSkills([...listOfAddedSkills, v])
          setListOfSkills([...updatedSkills, v])
        } else {
          setListOfSkills(updatedSkills)
        }
      }
    } catch (error) {
      console.error(`Error searching ${searchConfig?.skills?.name}:`, error)
    }
  }
  const pendingWorkExpp = pendingData?.resume?.workExperience?.length > 0

  useEffect(() => {
    const fetchData = async () => {
      try {
        setSkillLoading(true)
        await SkillsAPI(0)
      } finally {
        setSkillLoading(false)
      }
    }

    fetchData()
  }, [])

  useEffect(() => {
    const fetchTpoConfig = async () => {
      try {
        const instituteCampusId = studentFormData?.student?.instituteCampusId
        if (instituteCampusId) {
          const response = await instituteRequest.get(
            `/institutes/${instituteCampusId}/tpo-approval-config`
          )
          if (response?.data?.data) {
            setTpoConfig(response.data.data)
          }
        }
      } catch (error) {
        console.error('Error fetching TPO config:', error)
      }
    }
    fetchTpoConfig()
  }, [studentFormData?.student?.instituteCampusId])

  useEffect(() => {
    if (!tpoConfig || !tpoConfig.tpoApprovalConfig || !tpoConfig.tpoApprovalConfig.fields) {
      setFrozenFieldsMap({})
      setIsAddNewFrozen(false)
      return
    }

    const approvedWorkExp = studentFormData?.resume?.workExperience || []
    const frozen = {}
    const fields = tpoConfig.tpoApprovalConfig.fields
    
    const addNewConfig = fields['workExperience.addNew']
    const hasApprovedWorkExp = approvedWorkExp.length > 0
    setIsAddNewFrozen(addNewConfig?.freezeAfterVerification && hasApprovedWorkExp)

    approvedWorkExp.forEach((workExp) => {
      if (!workExp.id) return
      const workExpId = workExp.id
      frozen[workExpId] = {}

      const fieldMappings = {
        'title': 'title',
        'organization': 'organization',
        'started_in': ['startMonth', 'startYear'],
        'ended_in': ['endMonth', 'endYear'],
        'description': 'description',
        'skill_set': 'skill_set',
        'function': 'function',
        'role': 'role',
        'industry': 'industry',
        'noticePeriod': 'noticePeriod',
        'jobType': 'jobType'
      }

      Object.entries(fieldMappings).forEach(([uiField, configFields]) => {
        const configFieldArray = Array.isArray(configFields) ? configFields : [configFields]
        
        const shouldFreeze = configFieldArray.some(configField => {
          const fullFieldName = `workExperience.${configField}`
          const fieldConfig = fields[fullFieldName]
          return fieldConfig && fieldConfig.freezeAfterVerification
        })

        if (shouldFreeze) {
          const fieldValue = workExp[uiField]
          const hasValue = fieldValue !== null && fieldValue !== undefined && fieldValue !== '' && 
                           (!Array.isArray(fieldValue) || fieldValue.length > 0)
          if (hasValue) {
            frozen[workExpId][uiField] = true
          }
        }
      })
    })

    setFrozenFieldsMap(frozen)
  }, [tpoConfig, studentFormData?.resume?.workExperience])

  const dispatch = new useDispatch()
  const formRef = React.createRef()
  const [localPendingItems, setLocalPendingItems] = useState(new Map()) // Track frontend pending items
    useEffect(() => {
    try {
      let experienceList = []
      
      const approvedWorkExp = studentFormData?.resume?.workExperience || []
      const pendingWorkExp = (pendingData && pendingData?.resume?.workExperience) || []
      
      const pendingMap = new Map()
      pendingWorkExp.forEach(pendingItem => {
        if (pendingItem.id && !pendingItem.id.startsWith('temp-')) {
          pendingMap.set(pendingItem.id, pendingItem)
        }
      })
      
      const mergedWorkExp = approvedWorkExp.map(approvedItem => {
        const pendingItem = pendingMap.get(approvedItem.id)
        if (pendingItem && pendingItem._pendingFields) {
          const merged = { ...approvedItem }
          Object.keys(pendingItem._pendingFields).forEach(fieldName => {
            merged[fieldName] = pendingItem._pendingFields[fieldName].value
          })
          return merged
        }
        return approvedItem
      })
      
      const newPendingWorkExp = pendingWorkExp.filter(item => 
        !item.id || item.id.startsWith('temp-') || item._isNew
      )
      
      const allWorkExp = [...mergedWorkExp, ...newPendingWorkExp]
      
      allWorkExp.map((data, index) => {
      if (data?.isCurrentlyWorking === true) {
        setIsPresent(true)
      }
      let formName = 'experience_' + index
      const formattedDescription = Array.isArray(data?.description)
        ? data.description.map(item => `${item}`).join('\n')
        : data?.description
      form.setFieldsValue({
        [formName]: {
          id: data?.id,
          temp_id: data?.temp_id,
          corporateId: data?.corporateId,
          organization: data?.organization,
          title: data?.title,
          started_in: data?.started_in,
          ended_in: data?.ended_in,
          function: data?.function,
          role: data?.role,
          industry: data?.industry,
          description: formattedDescription,
          skill_set: data?.skill_set,
          certificate: data?.certificate,
          awards: data?.awards,
          noticePeriod: data?.noticePeriod,
          isCurrentlyWorking: data?.isCurrentlyWorking,
          jobType: data?.jobType,
          isDelete: false,
          shown: true,
        },
      })

      return experienceList.push({
        component: ExperienceForm,
        formName: formName,
      })
    })
      setExperience(experienceList)
    } catch (error) {
      console.error('Error in WorkExperienceDrawer useEffect:', error)
      setExperience([])
    }
  }, [studentFormData, pendingData])

  const experienceHandler = (isAdd, isDelete, deleteForm) => {
    if (isAdd) {
      let arr = []
      let formName = 'experience_' + experience?.length
      arr.push({ component: ExperienceForm, formName: formName, pendingFields: {}, _hasPendingChanges: false, _isNew: false })
      setIsUpdateButtonEnabled(false)
      setExperience(exp => exp.concat(arr))
    }
    if (isDelete) {
      let formDataCurrent = form.getFieldValue(deleteForm)
      if (formDataCurrent?.isCurrentlyWorking === true) {
        setIsPresent(false)
      }

      form.setFieldValue([[deleteForm], 'isDelete'], true)

      let formDatas = form.getFieldValue()
      let updatedList = []
      experience
        .filter(value => value.formName !== deleteForm)
        .forEach((data, index) => {
          let newFormName = 'experience_' + index
          Object.entries(formDatas).forEach(([name, item]) => {
            let currentFormValue = item
            if (name.includes(data?.formName)) {
              form.setFieldsValue({
                [name]: null,
              })
              if (name?.includes('award')) {
                let awardIndex = name?.split('_')[3]
                let newAwardName = newFormName + '_award_' + awardIndex
                form.setFieldsValue({
                  [newAwardName]: {
                    ...currentFormValue,
                  },
                })
              } else {
                form.setFieldsValue({
                  [newFormName]: {
                    ...currentFormValue,
                  },
                })
                updatedList.push({
                  component: ExperienceForm,
                  formName: newFormName,
                  pendingFields: data?.pendingFields || {},
                  _hasPendingChanges: data?._hasPendingChanges || false,
                  _isNew: data?._isNew || false,
                })
              }
            }
          })
        })

      setIsUpdateButtonEnabled(false)

      setExperience(updatedList)
      setIsExpUpdated(true)
    }
  }
  const uuidRegex =
    /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i
  const submitHandler = async () => {    
    if (submitLoading) {
      return
    }
    
    setSubmitLoading(true)
    
    try {
      let experience = []
      const values = await form.getFieldValue()
      const errorList = []
      await form
        .validateFields()
        .then()
        .catch(err => {
          errorList.push(err?.errorFields)
        })
      if (!errorList?.length) {
      Object.entries(values).forEach(([name, obj]) => {
        if (
          name.includes('experience') &&
          !name.includes('award') &&
          !obj?.isDelete &&
          obj
        ) {
          experience.push({
            ...obj,
            formName: name,
            employee_type: '',
            workExperience: '',
            work_location: '',
            significant_outcome: '',
            awards: [],
          })
        }
      })
      experience?.forEach((data, index) => {
        let awardData = []
        Object.entries(values).forEach(([name, obj]) => {
          let keyName = data?.formName + '_award_'
          if (name?.includes(keyName) && obj) {
            // Check if obj has a certificate and it is an empty object
            if (obj?.certificate && Object.keys(obj.certificate).length === 0) {
              delete obj.certificate // Remove the certificate property from obj
            }
            awardData.push(obj)
            data.awards.push(obj)
          }
        })
        delete data?.formName
      })
      experience = experience.map(proj => ({
          ...proj,
          skill_set: proj.skill_set
            ? proj.skill_set.map(skill => ({
                id: uuidRegex.test(skill.id) ? skill.id : '',
                name: skill.name,
              }))
            : [],
        }));

      // Track new items for frontend pending state
      const newLocalPendingItems = new Map()
      const existingWorkExpIds = new Set((studentFormData?.resume?.workExperience || []).map(exp => exp.id))

      experience.forEach((exp, index) => {
        // If this is a new item (no ID or not in existing items), mark as new without temp ID
        if (!exp.id || !existingWorkExpIds.has(exp.id)) {
          console.log('WorkExperienceDrawer - DEBUG tracking new item:', exp)
          exp._isNew = true
        } else {
          console.log('WorkExperienceDrawer - DEBUG skipping existing item:', exp.id)
        }
      })

      let payload = {
        isDirectTPOUpdate: true,
        checkDeleteSection: ['workExperience'],
        admin: {
          ...studentFormData?.admin,
          countryCode: studentFormData?.admin?.countryCode,
        },
        student: studentFormData?.student ? {
          ...studentFormData?.student,
          id: studentId,
          instituteCampusId: studentFormData?.student?.instituteCampusId || studentFormData?.admin?.institute_campus_id,
        } : {
          id: studentId,
          instituteCampusId: studentFormData?.admin?.institute_campus_id,
        },
        studentPersonalProfile: studentFormData?.studentPersonalProfile,
        currentCourse: !studentFormData?.student?.isExpCandidate
          ? {
              ...studentFormData?.currentCourse,
              marks: studentFormData?.currentCourse?.marks ?? 0,
            }
          : {},
        education: studentFormData?.education,
        resume: {
          ...studentFormData?.resume,
          workExperience:
            experience?.length < 0
              ? studentFormData?.resume?.workExperience
              : experience,
        },
      }

      payload?.resume?.workExperience?.map((workExp, indexWrk) => {
        workExp?.awards?.map((award, index) => {
          if (
            award?.certificate == null ||
            Object.keys(award?.certificate)?.length == 0
          ) {
            delete payload?.resume?.workExperience[indexWrk]?.awards[index]
              ?.certificate
          }
        })
      })

      if (payload?.currentCourse?.specialisationId === null) {
        delete payload?.currentCourse?.specialisationId
      }
      if (payload?.studentPersonalProfile?.secondaryEmail === null) {
        delete payload?.studentPersonalProfile?.secondaryEmail
      }
      if (payload?.studentPersonalProfile?.secondaryEmail === '') {
        delete payload?.studentPersonalProfile?.secondaryEmail
      }
      if (payload?.studentPersonalProfile?.registraionNo) {
        delete payload?.studentPersonalProfile?.registraionNo
      }
      if (payload?.currentCourse?.degreeStreamMapId === null) {
        delete payload?.currentCourse?.degreeStreamMapId
      }

      studentFormData?.education?.map((item, index) => {
        if (item?.skills === null) delete payload?.education?.[index]?.skills
        if (item?.degreeStreamMapId === null)
          delete payload?.education?.[index]?.degreeStreamMapId
      })
      const response = await updateStudentData(payload)
      await dispatch(setResumeData(payload))
      
      dispatch(getStudentDataById(studentId)).catch(err => console.error('getStudentData error:', err))
      getPendingData().catch(err => console.error('getPendingData error:', err))
      
      setSubmitLoading(false)
      
      if (response?.success === true) {
        SuccessMessage('Work experience info saved successfully!')
        setdrawerStatus(false)
        setUpdated(true)
        if (setExpDrawer) {
          setExpDrawer(true)
        }
        if (getEligibleDetails) {
          getEligibleDetails({ roleID: itemId, setLoading })
        }
        if (getRoleFloatDetails) {
          getRoleFloatDetails({ setLoading })
        }
      } else {
        ErrorMessage(response?.response?.data?.message)
      }
    } else {
      const errorForms = []

      errorList.map(item => {
        item.map(innerItem => {
          if (!errorForms.includes(innerItem?.name[0][0])) {
            errorForms.push(innerItem?.name[0][0])
          }
        })
      })
      const updatedValues = {}
      Object.keys(values).forEach(key => {
        if (errorForms.includes(key)) {
          updatedValues[key] = {
            ...values[key],
            shown: true,
          }
        } else {
          updatedValues[key] = {
            ...values[key],
          }
        }
      })

      form.setFieldsValue(updatedValues)
      setShown(errorForms)
      setSubmitLoading(false)
    }
    } catch (error) {
      console.error('Error in submitHandler:', error)
      ErrorMessage('An error occurred while submitting. Please try again.')
      setSubmitLoading(false)
    }
  }

  const content = () => {
    return (
      <>
        <Form
          scrollToFirstError
          onFinish={submitHandler}
          id={'experienceForm'}
          form={form}
          formRef={formRef}
          layout="vertical"
        >
          {!!experience?.length &&
            experience?.map((obj, idx) => {
              const approvedWorkExp = studentFormData?.resume?.workExperience || []
const pendingRequests = pendingData?.requests || [] 
const workExpPendingMap = new Map()

pendingRequests.forEach(request => {
  if (request.fieldName?.startsWith('workExperience.') && request.itemId) {
    if (!workExpPendingMap.has(request.itemId)) {
      workExpPendingMap.set(request.itemId, {})
    }

    const fieldName = request.fieldName.replace('workExperience.', '')

    workExpPendingMap.get(request.itemId)[fieldName] = {
      value: request.requestedData,
      originalValue: request.originalData,
      status: request.status,
      _requestId: request.id
    }
  }
})
const newWorkExpRequests = pendingRequests.filter(request =>
  request.fieldName === 'workExperience' &&
  request.isNewItem === true &&
  request.status === 'PENDING'
)

const newPendingWorkExp = []

newWorkExpRequests.forEach(request => {
  const newItem = {
    ...request.requestedData,
    id: request.itemId,
    _isNew: true,
    _hasPendingChanges: true,
    _pendingFields: {}
  }

  Object.keys(request.requestedData || {}).forEach(fieldName => {
    newItem._pendingFields[fieldName] = {
      value: request.requestedData[fieldName],
      originalValue: null,
      status: request.status,
      _requestId: request.id
    }
  })

  newPendingWorkExp.push(newItem)
})      
       const mergedWorkExp = approvedWorkExp.map(item => {
  const pendingFields = workExpPendingMap.get(item.id)

  if (pendingFields && Object.keys(pendingFields).length > 0) {
    const merged = { ...item }

    Object.keys(pendingFields).forEach(field => {
      merged[field] = pendingFields[field].value
    })

    merged._hasPendingChanges = true
    merged._pendingFields = pendingFields

    return merged
  }

  return item
})

const allWorkExp = [...mergedWorkExp, ...newPendingWorkExp]
              const currentWorkExp = allWorkExp[idx]
              const workExpId = currentWorkExp?.id
              const frozenFields = workExpId ? frozenFieldsMap[workExpId] || {} : {}
              
              return (
                <obj.component
                  key={idx + 'experience'}
                  form={form}
                  formRef={formRef}
                  onRemove={experienceHandler}
                  formName={obj?.formName}
                  studentFormData={studentFormData}
                  listOfStudentSkills={listOfStudentSkills}
                  isPresent={isPresent}
                  setIsPresent={setIsPresent}
                  corporateName={corporateName}
                  setCorporateName={setCorporateName}
                  setCorporateId={setCorporateId}
                  corporateId={corporateId}
                  getListOfSkills={getListOfSkills}
                  setIsUpdateButtonEnabled={setIsUpdateButtonEnabled}
                  skillLoading={skillLoading}
                  setSkillLoading={setSkillLoading}
                  listOfSkills={listOfSkills}
                  SkillsAPI={SkillsAPI}
                  isExpUpdated={isExpUpdated}
                  shown={shown}
                  frozenFields={frozenFields}
                  pendingFields={currentWorkExp?._pendingFields || {}}
                  _hasPendingChanges={currentWorkExp?._hasPendingChanges || false}
                  isNew={currentWorkExp?._isNew || false}
                />
              )
            })}
        </Form>
        <SubHeading1>Note:</SubHeading1>
        <SubHeading1>
          Add all the details in the work experience section to increase the
          chance of recruiters considering your profile
        </SubHeading1>
        <ButtonLocal 
          onClick={() => !isAddNewFrozen && experienceHandler(true, false)}
          disabled={isAddNewFrozen}
          style={{ 
            opacity: isAddNewFrozen ? 0.5 : 1, 
            cursor: isAddNewFrozen ? 'not-allowed' : 'pointer' 
          }}
        >
          <Control alignCenter gap="10px">
            <AdjustIcon>
              <AddIcon />
            </AdjustIcon>
            <Text>Add Work Experience</Text>
          </Control>
        </ButtonLocal>
        {studentFormData?.resume?.workExperience?.length > 0 &&
          skillLoading && (
            <SpinWrapper center>
              <Spin />
            </SpinWrapper>
          )}
      </>
    )
  }
  const footer = () => {
    return (
      <FooterFlex right>
        <Button.Secondary
          text="Cancel"
          onClick={() => {
            setdrawerStatus(false)
          }}
        />
        <Button.Primary
          onClick={async () => {
            try {
              await form.validateFields()
              if(!pendingWorkExpp) {                
                form.submit()
              }
              else {
                setShowUpdatePopup(true)
              }
            } catch (err) {
            }
          }}
          text={'Update'}
          disabled={isUpdateButtonEnabled || submitLoading}
          loading={submitLoading}
        />
      </FooterFlex>
    )
  }
  return (
    <>
          <UpdatePopup
        form={'experienceForm'}
        htmlType="submit"
        open={showUpdatePopup}
        loading={submitLoading}
        onCancel={() => setShowUpdatePopup(false)}
        onConfirm={() => {
          setShowUpdatePopup(false)
          setSuccessPopup(true)
          form.submit()  
        }}
      />
      <SuccessPopupModal
        open={succesPopup}
        onClose={() => setSuccessPopup(false)}
      />
    <StyledDrawer
      width="675px"
      title={'Work Experience'}
      placement="right"
      closable={true}
      onClose={() => setdrawerStatus(false)}
      visible={drawerStatus}
      content={content()}
      footer={footer()}
    />
    </>
  )
}

export default WorkExperienceDrawer
